// extracted by mini-css-extract-plugin
export var documentation = "_kq-1";
export var menu = "_kq-0";